import { render, staticRenderFns } from "./userCenter.vue?vue&type=template&id=28fc038b&scoped=true&"
import script from "./userCenter.vue?vue&type=script&lang=js&"
export * from "./userCenter.vue?vue&type=script&lang=js&"
import style0 from "./userCenter.vue?vue&type=style&index=0&id=28fc038b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fc038b",
  null
  
)

export default component.exports